/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { useLocale } from "@epic-mw/i18n";

import { CosmosText } from "@components/elements";
import { dateToTimeAgo } from "@components/utils/dateFormatters";
import { cx, css } from "@panda/css";
import { hstack } from "@panda/patterns";
import { CosmosElementLearnImageCardSourceFragment } from "@cosmos/hygraph-schema";

export type SourceProps = CosmosElementLearnImageCardSourceFragment & {
	className?: string;
};

export const Source = ({ author, timestamp, className }: SourceProps): React.JSX.Element => {
	const locale = useLocale();
	const text = [];

	if (author) {
		text.push(author);
	}
	if (timestamp) {
		const safeTimestamp = typeof timestamp === "string" ? timestamp : String(timestamp);
		text.push(dateToTimeAgo(safeTimestamp, locale));
	}

	return (
		<div
			className={cx(
				"reactions",
				hstack({
					alignItems: "center",
					gap: "eds.dimension.20",
				}),
				css({ flexGrow: 0 }),
				className,
			)}
		>
			<CosmosText variant="uiSM" color="eds.text.secondary">
				{text.join(" · ")}
			</CosmosText>
		</div>
	);
};
